import React from 'react';

export default class  Page3 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>SELF ASSERTION EXERCISE</div>
                                            <p>This exercise<a className="superscripttext"
                                                               href="further_info.php?course=300"><sup>3</sup></a> will
                                                help you identify whether you need to improve your skills in
                                                certain circumstances or when dealing with particular people. It
                                                has three stages to work through – and an activity sheet to
                                                reinforce what you learn.</p>
                                            <div className="border_subtitle">Stage one – Identify levels of
                                                assertiveness
                                            </div>
                                            <p>You will need to use the table below for this. The top row of the
                                                table describes different types of work relationships; for
                                                example, ‘Peripheral Relationships’ (PAs, cleaners, IT support,
                                                etc.), or ‘Equality Relationships’ (includes others doing the
                                                same job as you). Additionally, there are ‘subordinate’ or
                                                ‘superordinate’ relationships which involve workers who are
                                                directly reportable to you, or who you are directly reportable
                                                to, respectively.</p>
                                            <p>Underneath each heading, there is space for you to put the name
                                                of a person you know who fits the descriptions.</p>
                                            <p>Next, work down the actions on the left to assess your levels of
                                                assertiveness with each of the specified people. A good way of
                                                judging your assertiveness in a given situation is to ask: <span
                                                    className="subtiltereg">
‘Do I feel comfortable carrying out this activity with this person?’.</span></p>
                                            <p>Rate your response on a scale of 1-4 and insert the number into
                                                the table.</p>
                                            <p><span className="brown boldtext stage contentSpaceRight space"
                                                     style={{marginLeft: '-18px'}}>1.</span> Very
                                                uncomfortable <span
                                                    className="brown boldtext stage contentSpaceRight">2.</span> Uncomfortable <span
                                                    className="brown boldtext stage contentSpaceRight">3.</span> Comfortable <span
                                                    className="brown boldtext stage contentSpaceRight">4.</span> Very
                                                comfortable</p></div>
                                        <p>Once it is completed, this table will help you carry out the next
                                            stage of the tool, where you will look at some of these activities
                                            in more detail by identifying the areas where you feel most
                                            uncomfortable being assertive.</p>
                                        <div className="mobile-scroll">


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  tablesrink ilead_v_sport1">
                                                <tbody>
                                                <tr>
                                                    <th width="20%" align="left" valign="top"
                                                        className="green_curve">Activity
                                                    </th>
                                                    <th width="80%" align="left" valign="top" colSpan="8"
                                                        className=" green_curve1">Person
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="20%" align="left" valign="top"
                                                        className="lightgreen subheadingbg"><span
                                                        className="subtitle-table"></span>
                                                    </td>


                                                    <td align="left" valign="top"
                                                        className="lightgreen subheadingbg"><span
                                                        className="subtitle-table"><p
                                                        style={{paddingBottom: '18px !important'}}> Peripheral relationships (porters, office cleaners, jobs unrelated to ours)</p></span>
                                                        <input type="text"
                                                               id="name"
                                                               name="name"
                                                               onChange={this.props.handleChangePageData('Person1')}
                                                               value={pageData?.Person1?.name}/></td>

                                                    <td align="left" valign="top"
                                                        className="lightgreen subheadingbg"><span
                                                        className="subtitle-table"><p> Superordinate relationships (individuals we manage or that work under us)</p></span>
                                                        <input type="text"
                                                               id="name"
                                                               name="name"
                                                               onChange={this.props.handleChangePageData('Person2')}
                                                               value={pageData?.Person2?.name}/></td>

                                                    <td align="left" valign="top"
                                                        className="lightgreen subheadingbg"><span
                                                        className="subtitle-table"><p> Equality relationships (colleagues or people performing the same job/grade)</p></span>
                                                        <input type="text"
                                                               id="name"
                                                               name="name"
                                                               onChange={this.props.handleChangePageData('Person3')}
                                                               value={pageData?.Person3?.name}/></td>

                                                    <td align="left" valign="top"
                                                        className="lightgreen subheadingbg"><span
                                                        className="subtitle-table"><p
                                                        style={{paddingBottom: '18px !important'}}> Subordinate relationships (people we are directly answerable to, boss)</p></span>
                                                        <input type="text"
                                                               id="name"
                                                               name="name"
                                                               onChange={this.props.handleChangePageData('Person4')}
                                                               value={pageData?.Person4?.name}/></td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Giving praise</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="GivingPraise" 
                                                                id="GivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.GivingPraise}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="GivingPraise"
                                                                id="GivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.GivingPraise}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="GivingPraise"
                                                                id="GivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.GivingPraise}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="GivingPraise"
                                                                id="GivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.GivingPraise}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="darkgreen"><span
                                                        className="subtitle-table uiheading"><p>Receiving praise</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ReceivingPraise"
                                                                id="ReceivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.ReceivingPraise}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ReceivingPraise"
                                                                id="ReceivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.ReceivingPraise}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ReceivingPraise"
                                                                id="ReceivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.ReceivingPraise}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ReceivingPraise"
                                                                id="ReceivingPraise"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.ReceivingPraise}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Expressing
emotions</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingEmotions"
                                                                id="ExpressingEmotions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.ExpressingEmotions}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingEmotions"
                                                                id="ExpressingEmotions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.ExpressingEmotions}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingEmotions"
                                                                id="ExpressingEmotions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.ExpressingEmotions}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingEmotions"
                                                                id="ExpressingEmotions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.ExpressingEmotions}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="darkgreen"><span
                                                        className="subtitle-table uiheading"><p>Making requests
(help, favours)</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MakingRequestsHelpFavours"
                                                                id="MakingRequestsHelpFavours"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.MakingRequestsHelpFavours}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MakingRequestsHelpFavours"
                                                                id="MakingRequestsHelpFavours"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.MakingRequestsHelpFavours}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MakingRequestsHelpFavours"
                                                                id="MakingRequestsHelpFavours"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.MakingRequestsHelpFavours}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MakingRequestsHelpFavours"
                                                                id="MakingRequestsHelpFavours"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.MakingRequestsHelpFavours}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Maintaining equal
conversations</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MaintainingEqualConversations"
                                                                id="MaintainingEqualConversations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.MaintainingEqualConversations}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                       <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MaintainingEqualConversations"
                                                                id="MaintainingEqualConversations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.MaintainingEqualConversations}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MaintainingEqualConversations"
                                                                id="MaintainingEqualConversations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.MaintainingEqualConversations}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="MaintainingEqualConversations"
                                                                id="MaintainingEqualConversations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.MaintainingEqualConversations}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="darkgreen"><span
                                                        className="subtitle-table uiheading"><p>Standing up for
your own rights</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="StandingUpForYourOwnRights"
                                                                id="StandingUpForYourOwnRights"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.StandingUpForYourOwnRights}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="StandingUpForYourOwnRights"
                                                                id="StandingUpForYourOwnRights"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.StandingUpForYourOwnRights}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="StandingUpForYourOwnRights"
                                                                id="StandingUpForYourOwnRights"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.StandingUpForYourOwnRights}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="StandingUpForYourOwnRights"
                                                                id="StandingUpForYourOwnRights"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.StandingUpForYourOwnRights}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Refusing
requests</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingRequests"
                                                                id="RefusingRequests"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.RefusingRequests}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                         <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingRequests"
                                                                id="RefusingRequests"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.RefusingRequests}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                       <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingRequests"
                                                                id="RefusingRequests"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.RefusingRequests}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingRequests"
                                                                id="RefusingRequests"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.RefusingRequests}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="darkgreen"><span
                                                        className="subtitle-table uiheading"><p>Refusing invitations</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingInvitations"
                                                                id="RefusingInvitations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.RefusingInvitations}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingInvitations"
                                                                id="RefusingInvitations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.RefusingInvitations}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingInvitations"
                                                                id="RefusingInvitations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.RefusingInvitations}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="RefusingInvitations"
                                                                id="RefusingInvitations"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.RefusingInvitations}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Expressing personal opinions</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingPersonalOpinions"
                                                                id="ExpressingPersonalOpinions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.ExpressingPersonalOpinions}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                         <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingPersonalOpinions"
                                                                id="ExpressingPersonalOpinions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.ExpressingPersonalOpinions}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingPersonalOpinions"
                                                                id="ExpressingPersonalOpinions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.ExpressingPersonalOpinions}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingPersonalOpinions"
                                                                id="ExpressingPersonalOpinions"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.ExpressingPersonalOpinions}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="darkgreen"><span
                                                        className="subtitle-table uiheading"><p>Expressing annoyance / displeasure</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                         <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingAnnoyanceDispleasure"
                                                                id="ExpressingAnnoyanceDispleasure"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.ExpressingAnnoyanceDispleasure}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingAnnoyanceDispleasure"
                                                                id="ExpressingAnnoyanceDispleasure"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.ExpressingAnnoyanceDispleasure}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingAnnoyanceDispleasure"
                                                                id="ExpressingAnnoyanceDispleasure"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.ExpressingAnnoyanceDispleasure}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="darkgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingAnnoyanceDispleasure"
                                                                id="ExpressingAnnoyanceDispleasure"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.ExpressingAnnoyanceDispleasure}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="20%" align="left" valign="center"
                                                        className="lightgreen"><span
                                                        className="subtitle-table uiheading"><p>Expressing justified anger</p></span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                      <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingJustifiedAnger"
                                                                id="ExpressingJustifiedAnger"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person1?.ExpressingJustifiedAnger}
                                                                onChange={this.props.handleChangePageData('Person1')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                         <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingJustifiedAnger"
                                                                id="ExpressingJustifiedAnger"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person2?.ExpressingJustifiedAnger}
                                                                onChange={this.props.handleChangePageData('Person2')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                         <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingJustifiedAnger"
                                                                id="ExpressingJustifiedAnger"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person3?.ExpressingJustifiedAnger}
                                                                onChange={this.props.handleChangePageData('Person3')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>


                                                    <td align="left" valign="center" className="lightgreen">
                                                        <span className="ilead-slect-box-yellow">
                                                            <select
                                                                name="ExpressingJustifiedAnger"
                                                                id="ExpressingJustifiedAnger"
                                                                className="custom-dropdown"
                                                                value={pageData?.Person4?.ExpressingJustifiedAnger}
                                                                onChange={this.props.handleChangePageData('Person4')}>

                                                                <option value="select">Select</option>
                                                                <option value="very_uncomfortable">1- Very uncomfortable</option>
                                                                <option value="uncomfortable">2- Uncomfortable</option>
                                                                <option value="comfortable">3- Comfortable</option>
                                                                <option value="very_comfortable">4- Very comfortable</option>
                                                            </select>
                                                        </span>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="left-btn"><div
                                            onClick={this.props.handleChangePage('Page2')}
                                            className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                        <div className="right-btn"><div
                                            onClick={this.props.savePageData('Page4')}
                                            className="button-next-previous-done">Next &gt;&gt;</div></div>

                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}